<!-- nlc-style Header -->
<app-page-header
  title="Ausstehende Aufträge"
  subtitle="Übersicht aller Aufträge, die auf Genehmigung warten"
  icon="pending_actions"
  variant="gradient">
</app-page-header>

<!-- nlc-style Content -->
<div class="nlc-slide-up">
  <div class="nlc-pending-orders-content">
    <!-- Orders Table Card -->
    <div class="nlc-card orders-card">
      <div class="nlc-card-header">
        <div class="nlc-card-icon orders-icon">
          <mat-icon>pending_actions</mat-icon>
        </div>
        <div class="nlc-card-title-section">
          <h3>Ausstehende Aufträge</h3>
          <p class="nlc-body-secondary">
            {{ (pendingOrders$ | async)?.length || 0 }} Aufträge warten auf Genehmigung
          </p>
        </div>
      </div>

      <div class="nlc-card-content">
        <div class="orders-table-wrapper">
          <table class="nlc-table">
            <thead>
              <tr>
                <th class="nlc-table-header">Auftragsnr.</th>
                <th class="nlc-table-header">Kunde</th>
                <th class="nlc-table-header">Status</th>
                <th class="nlc-table-header">Anzahl Coins</th>
                <th class="nlc-table-header">Coins angewendet am</th>
                <th class="nlc-table-header">Angewendet von</th>
                <th class="nlc-table-header">Aktionen</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let order of pendingOrders$ | async" class="nlc-table-row status-pending">
                <td class="nlc-table-cell">{{ order.reflexOrderNo }}</td>
                <td class="nlc-table-cell">
                  <div class="customer-info">
                    <mat-icon class="customer-icon">business</mat-icon>
                    <span>{{ order.customer?.reflexCustomerNo || order.customer?.customerReflexId || 'N/A' }}</span>
                  </div>
                </td>
                <td class="nlc-table-cell">
                  <span class="status-badge badge-pending">
                    {{ order.status?.name }}
                  </span>
                </td>
                <td class="nlc-table-cell">
                  <span class="coins-value">{{ order.coinsUsed }}</span>
                </td>
                <td class="nlc-table-cell">
                  {{ order.createdDate | date : "dd.MM.yyyy HH:mm" : "UTC" }}
                </td>
                <td class="nlc-table-cell">
                  <div class="user-info">
                    <mat-icon class="user-icon">person</mat-icon>
                    <span>
                      {{ order.customer?.userDetails?.firstName }}
                      {{ order.customer?.userDetails?.lastName }}
                    </span>
                  </div>
                </td>
                <td class="nlc-table-cell actions-cell">
                  <button 
                    class="nlc-button nlc-button-small nlc-button-success" 
                    matTooltip="Genehmigen"
                    [disabled]="!order.id"
                    (click)="order.id && changeOrderStatus(order.id, 'approve')">
                    <mat-icon>check_circle</mat-icon>
                  </button>
                  <button 
                    class="nlc-button nlc-button-small nlc-button-error" 
                    matTooltip="Ablehnen"
                    [disabled]="!order.id"
                    (click)="order.id && changeOrderStatus(order.id, 'decline')">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="(pendingOrders$ | async)?.length === 0" class="nlc-table-row empty-state">
                <td colspan="7" class="nlc-table-cell empty-cell">
                  <div class="empty-state-content">
                    <mat-icon class="empty-icon">check_circle</mat-icon>
                    <p class="empty-message">Keine ausstehenden Aufträge</p>
                    <p class="empty-submessage">Alle Aufträge wurden bearbeitet</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
